/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import Breadcrumb from "../../components/Breadcrumb";
import ContentLessonPlans from "../../components/LessonPlans";
import Loading from "../../components/Loading";
import ProtectedRoute from "../../components/ProtectedRoute";
import URL from "../../config/api";
import axios from "../../config/axios";

class LessonPlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      type: 0,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: [],
      word: ""
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    let isConstruir =
      this.props.general.active_roles.group_id === 45 ||
      this.props.general.active_roles.group_id === 92;

    if (this.props.location.state?.word) {
      this.setState({ word: this.props.location.state.word });
    }
    const { type } = this.props.match.params;
    axios
      .get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let responseData = resp.data.data;
        this.setState({ types: responseData, loading: false });
      });

    if (type) {
      this.setState({ type });
    }
  }

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : (
          <ContentLessonPlans
            type={this.state.type}
            typeName={this.state.typeName}
            typeIcon={this.state.typeIcon}
            typeColor={this.state.typeColor}
            types={this.state.types}
            currentRoute={this.props.currentRoute}
            serie={serie}
            discipline={discipline}
            word={this.state.word}
          />
        )}
        {/* <ProtectedRoute routeId={this.props.currentRoute} /> */}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LessonPlans);
